import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Solutions from "./pages/Solutions";
import Programs from "./pages/Programs";
import ProgramDetail from "./pages/ProgramDetail";
import Apply from "./pages/Apply";
import Dashboard from "./pages/Dashboard";
import AdminPrograms from "./pages/AdminPrograms";
import ApplicationEdit from "./pages/ApplicationEdit";
import AdminApplicationReview from "./pages/AdminApplicationReview";
import AdminUsers from "./pages/AdminUsers";
import AdminEvaluatorAssignments from "./pages/AdminEvaluatorAssignments";
import EvaluatorDashboard from "./pages/EvaluatorDashboard";
import OrganizationDashboard from "./pages/OrganizationDashboard";
import ChallengeDashboard from "./pages/organization/ChallengeDashboard";
import AIEvaluators from "./pages/organization/AIEvaluators";
import UserProfile from "./pages/UserProfile";
import { Toaster } from "./components/ui/toaster";
import { LanguageProvider } from "./context/LanguageContext";
import { AuthProvider } from "./context/AuthContext";
import Login from "./pages/Login";
import Register from "./pages/Register";
import PaymentResult from "./pages/PaymentResult";
import ApplyWelcome from "./pages/ApplyWelcome";
import AdminEmailSettings from "./pages/AdminEmailSettings";
import AdminImageManager from "./pages/AdminImageManager";
import AdminPlans from "./pages/AdminPlans";
import AdminPages from "./pages/AdminPages";
import AdminImportUsers from "./pages/AdminImportUsers";
import SitePage from "./pages/SitePage";
import OpenInnovation from "./pages/OpenInnovation";
import Founders from "./pages/Founders";
import ProtectedRoute from "./components/ProtectedRoute";
import ScrollToTop from "./components/ScrollToTop";
import Team from "./pages/Team";
import AdminAIProfiles from "./pages/AdminAIProfiles";

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <div className="App">
          <BrowserRouter>
          <ScrollToTop />
          <Navbar />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/pricing" element={<Solutions />} />
              <Route path="/programs" element={<Programs />} />
              <Route path="/programs/:id" element={<ProgramDetail />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/payment-result" element={<PaymentResult />} />
              <Route path="/apply-welcome" element={<ApplyWelcome />} />
              
              {/* Protected Routes */}
              <Route path="/apply" element={
                <ProtectedRoute>
                  <Apply />
                </ProtectedRoute>
              } />
              <Route path="/dashboard" element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              } />
              <Route path="/application/:id/edit" element={
                <ProtectedRoute>
                  <ApplicationEdit />
                </ProtectedRoute>
              } />
              
              {/* User Profile - All authenticated users */}
              <Route path="/profile" element={
                <ProtectedRoute>
                  <UserProfile />
                </ProtectedRoute>
              } />
              
              {/* Evaluator Routes */}
              <Route path="/evaluator-dashboard" element={
                <ProtectedRoute requiredRole="evaluator">
                  <EvaluatorDashboard />
                </ProtectedRoute>
              } />
              
              {/* Organization Routes */}
              <Route path="/organization-dashboard" element={
                <ProtectedRoute requiredRole="organization">
                  <OrganizationDashboard />
                </ProtectedRoute>
              } />
              <Route path="/organization/challenge/:id" element={
                <ProtectedRoute requiredRole="organization">
                  <ChallengeDashboard />
                </ProtectedRoute>
              } />
              <Route path="/organization/ai-evaluators/:programId" element={
                <ProtectedRoute requiredRole="organization">
                  <AIEvaluators />
                </ProtectedRoute>
              } />
              <Route path="/organization/application/:id" element={
                <ProtectedRoute requiredRole="organization">
                  <AdminApplicationReview />
                </ProtectedRoute>
              } />
              
              {/* Admin Routes */}
              <Route path="/admin/programs" element={
                <ProtectedRoute requiredRole="admin">
                  <AdminPrograms />
                </ProtectedRoute>
              } />
              <Route path="/admin/application/:id" element={
                <ProtectedRoute requiredRole="admin">
                  <AdminApplicationReview />
                </ProtectedRoute>
              } />
              <Route path="/admin/users" element={
                <ProtectedRoute requiredRole="admin">
                  <AdminUsers />
                </ProtectedRoute>
              } />
              <Route path="/admin/evaluators" element={
                <ProtectedRoute requiredRole="admin">
                  <AdminEvaluatorAssignments />
                </ProtectedRoute>
              } />
              <Route path="/admin/email-settings" element={
                <ProtectedRoute requiredRole="admin">
                  <AdminEmailSettings />
                </ProtectedRoute>
              } />
              <Route path="/admin/images" element={
                <ProtectedRoute requiredRole="admin">
                  <AdminImageManager />
                </ProtectedRoute>
              } />
              <Route path="/admin/pages" element={
                <ProtectedRoute requiredRole="admin">
                  <AdminPages />
                </ProtectedRoute>
              } />
              <Route path="/admin/import-users" element={
                <ProtectedRoute requiredRole="admin">
                  <AdminImportUsers />
                </ProtectedRoute>
              } />
              <Route path="/admin/plans" element={
                <ProtectedRoute requiredRole="admin">
                  <AdminPlans />
                </ProtectedRoute>
              } />
              <Route path="/page/:slug" element={<SitePage />} />
              <Route path="/open-innovation" element={<OpenInnovation />} />
              <Route path="/founders" element={<Founders />} />
              <Route path="/team" element={<Team />} />
              <Route path="/admin/ai-profiles" element={
                <ProtectedRoute requiredRole="admin">
                  <AdminAIProfiles />
                </ProtectedRoute>
              } />
            </Routes>
            <Footer />
            <Toaster />
          </BrowserRouter>
        </div>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
